import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src879763043/src/codemochi-courses/src/components/routes/public/Lecture.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <div className="objective">
  <p>
    <span>Objective:</span> Drive home the importance of creating controlled
    form inputs by fixing the value of the GenerateIngredients input component
    to the current state.
  </p>
    </div>
    <p>{`In this step, we are just adding `}<inlineCode parentName="p">{`value={ingredient[name]}`}</inlineCode>{` to the `}<inlineCode parentName="p">{`<Input>`}</inlineCode>{` component. This changes how the component works- previously any changes that were made in the input were saved into the state in the `}<inlineCode parentName="p">{`submitForm`}</inlineCode>{` hook. When we submitted the form we'd take the data from that object and submit it as a mutation. The problem was that any changes that were made to the state did not make it back into the `}<inlineCode parentName="p">{`<Input>`}</inlineCode>{` component because the value was not fixed to the state of the `}<inlineCode parentName="p">{`submitForm`}</inlineCode>{`. By specifying that the value of the `}<inlineCode parentName="p">{`<Input>`}</inlineCode>{` is equal to the state `}<inlineCode parentName="p">{`ingredient[name]`}</inlineCode>{`, we ensure that state is only being stored in a single location (`}<inlineCode parentName="p">{`submitForm`}</inlineCode>{`) instead of what we had before which was that it was stored in two locations (`}<inlineCode parentName="p">{`submitForm`}</inlineCode>{` and internal state of `}<inlineCode parentName="p">{`<Input>`}</inlineCode>{`) that were synced together through the use of the `}<inlineCode parentName="p">{`handleInputChange`}</inlineCode>{` onChange handler.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-components/GenerateIngredients.tsx"
      }}>{`import { Row, Col, Button, Table, Input, Dropdown } from 'antd';
import { MenuList } from './MenuList';

type IngredientsProps = {
  names?: string[];
  values?: [{ amount: string; unit: string; type: string }];
  handleAddIngredient: (event: any) => void;
  handleDeleteIngredient: (event: any) => void;
  handleInputChange: (event: any) => void;
  handleDropdownChange: (event: any) => void;
};

const units = ['-', 'ounce', 'lb', 'cup', 'tb', 'tsp', 'g', 'kg'];

export const GenerateIngredients = ({
  names,
  values,
  handleAddIngredient,
  handleDeleteIngredient,
  handleInputChange,
  handleDropdownChange,
}: IngredientsProps) => {
  const columns = names.map((name) => ({
    title: \`\${name}\`,
    key: \`\${name}\`,
    render: (ingredient, _record, index: number) => {
      return name === 'unit' ? (
        <Dropdown
          overlay={
            <MenuList
              iterableList={units}
              name={\`ingredients[\${index}].\${name}\`}
              handleDropdownChange={handleDropdownChange}
            />
          }
          placement="bottomLeft"
        >
          <Button>{ingredient[name]}</Button>
        </Dropdown>
      ) : (
        <Input
          value={ingredient[name]}
          placeholder={\`\${name}\`}
          name={\`ingredients[\${index}].\${name}\`}
          onChange={handleInputChange}
        />
      );
    },
  }));

  return (
    <>
      <Row>
        <Col span={12} offset={6}>
          <p>
            <Button
              onClick={handleAddIngredient}
              type="primary"
              shape="circle"
              size="small"
            >
              +
            </Button>
            ingredients:
          </p>
        </Col>
      </Row>
      {values.length > 0 ? (
        <Row>
          <Col span={12} offset={6}>
            <Table
              dataSource={values}
              columns={columns}
              pagination={{ pageSize: 25 }}
            />
          </Col>
        </Row>
      ) : null}
    </>
  );
};

`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      